import { DifficultyLevelType } from "constants/difficulty";
import { translate } from "game/translate";
import { useEffect, useRef, useState } from "react";
 

interface Props {
    title: string;
    isSelected: boolean;
    type: DifficultyLevelType;
    difficultyKey: string;
    onSelectDifficulty: (difficulty: DifficultyLevelType) => void;
    onIconPointerLeave?: () => void;
    modalRef: React.RefObject<HTMLDivElement>;
    gameUiRef?: React.RefObject<HTMLDivElement>;
}

export const Difficulty = ({ title, isSelected, onSelectDifficulty, type, difficultyKey, onIconPointerLeave, modalRef, gameUiRef }: Props) => {

    const iconRef = useRef<SVGSVGElement>(null);

    const [key, setKey] = useState(Math.random().toString(36).substring(2, 15));

    useEffect(() => {
        if (isSelected) {
            setKey(Math.random().toString(36).substring(2, 15));
        }
    }, [isSelected]);

    return (
        <div className={`newgame-difficulty-container${isSelected ? ' newgame-difficulty-container--selected' : ''}`} onClick={() => onSelectDifficulty(type)}>
            <div className="newgame-difficulty-container-radio">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <circle cx="10" cy="10" r="9.5" stroke="white"/>
                    {isSelected && <circle cx="10" cy="10" r="6" fill="white"/>}
                </svg>
            </div>
            <span className="newgame-difficulty-container-name">{title}</span>
            {isSelected && <div key={key} className="newgame-difficulty-container-icon" onPointerLeave={onIconPointerLeave}>
                <svg ref={iconRef} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" opacity="0.6" fill="none">
                    <g filter="url(#filter0_d_15653_2828)">
                    <path d="M7.99707 0.125C12.347 0.125 15.8738 3.65115 15.874 8.00098C15.874 12.351 12.3471 15.8779 7.99707 15.8779C3.64725 15.8777 0.121094 12.3509 0.121094 8.00098C0.121336 3.6513 3.6474 0.125242 7.99707 0.125ZM7.19922 5.68164V12.8408H9.18555V5.68164H7.19922ZM8.19727 2.75C7.90224 2.75 7.64872 2.8492 7.4375 3.04785C7.22935 3.24358 7.12503 3.47857 7.125 3.75195C7.125 4.02847 7.22936 4.26599 7.4375 4.46484C7.64879 4.6606 7.90208 4.75879 8.19727 4.75879C8.49234 4.75873 8.74403 4.66054 8.95215 4.46484C9.16329 4.26602 9.26855 4.0284 9.26855 3.75195C9.26852 3.47857 9.16341 3.24358 8.95215 3.04785C8.74406 2.84916 8.49226 2.75006 8.19727 2.75Z" fill="white"/>
                    </g>
                    <defs>
                    <filter id="filter0_d_15653_2828" x="0.121094" y="0.125" width="15.7529" height="16.5148" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="0.761822"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15653_2828"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15653_2828" result="shape"/>
                    </filter>
                    </defs>
                </svg>
                <div className="newgame-difficulty-container-tooltip" style={{
                    left: `${(iconRef.current?.getBoundingClientRect().left || 0) - (modalRef.current?.getBoundingClientRect()?.left || 0)}px`,
                    top: `${(iconRef.current?.getBoundingClientRect().top || 0) - (gameUiRef?.current?.getBoundingClientRect()?.top || 0)}px`,
                }}>
                    {translate(`${difficultyKey}_info`)}
                    <svg style={{
                        position: 'fixed',
                        bottom: '-6px',
                        left: '112px',
                    }} xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                        <path d="M0 0L4.4 5.86667C5.2 6.93333 6.8 6.93333 7.6 5.86667L12 0L0 0Z" fill="#F3F3E9"/>
                    </svg>
                </div>
            </div>}
            
        </div>
    );
};